import { Container, IDestroyOptions, Sprite } from "pixi.js";
import { gsap } from "gsap";
import { MarketplaceResourcePackage } from "../../resources/MarketplaceResourcePackage";

export class MarketplaceMapCardLoader extends Container {
    private readonly marketplaceResources: MarketplaceResourcePackage;

    private loaderBg: Sprite;
    private loader: Sprite;
    private loaderAnimation: gsap.core.Timeline;
    private hideAnimation: gsap.core.Timeline;

    public constructor(
        marketplaceResources: MarketplaceResourcePackage
    ) {
        super();
        this.once("added", this.addedToStage.bind(this));

        this.marketplaceResources = marketplaceResources;
        this.loaderAnimation
        this.loaderBg = new Sprite(this.marketplaceResources.assets_views_marketplace_nftloaderbg_png);
        this.loaderBg.anchor.set(0.5);
        this.addChild(this.loaderBg);

        this.loader = new Sprite(this.marketplaceResources.assets_views_marketplace_loader_png);
        this.loader.anchor.set(0.5);
        this.addChild(this.loader);

        this.hideAnimation = new gsap.core.Timeline({ paused: true });
        this.loaderAnimation = new gsap.core.Timeline({ paused: true });
        this.loaderAnimation.to(this.loader, { angle: 360, repeat: -1, duration: 2, ease: "power1.inOut" });
    }

    private addedToStage(): void {
        this.alpha = 0;
    }

    public show(): void {
        this.alpha = 1;
        this.loaderAnimation.play();
    }

    public async hide(): Promise<void> {
        this.hideAnimation.to(this, { alpha: 0, duration: 1 });
        await this.hideAnimation.play();
        this.hideAnimation.clear();
        this.loaderAnimation.pause(0);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.loaderAnimation?.kill();
        this.hideAnimation?.kill();
        super.destroy(options);
    }
}
